export function stringifyVariableValue(value) {
    if (typeof value === 'string') {
        return value;
    }
    else if (typeof value === 'number' || typeof value === 'boolean') {
        return value.toString();
    }
    else {
        return JSON.stringify(value);
    }
}
//# sourceMappingURL=Variables.js.map